import React from "react";
import env from "./env";
import axios from "axios";
import {AUTH_MODE, storeAppSession} from "./auth/authStorage";
import {decodeAppToken} from "./auth/token";

function getTokenFromLocation() {
    // 1) BrowserRouter: /auth/callback?token=...
    if (window.location.search && window.location.search.length > 1) {
        const p = new URLSearchParams(window.location.search);
        const t = p.get('token');
        if (t) return t;
    }

    // 2) HashRouter: /#/auth/callback?token=...
    const hash = window.location.hash || '';        // "#/auth/callback?token=Bearer+eyJ..."
    const qIndex = hash.indexOf('?');
    if (qIndex >= 0) {
        const query = hash.substring(qIndex);         // "?token=Bearer+eyJ..."
        const p = new URLSearchParams(query);
        const t = p.get('token');
        if (t) return t;
    }
    return null;
}

export default function AuthCallback() {
    React.useEffect(() => {
        let token = getTokenFromLocation()
        if (token) {
            const decoded = decodeAppToken(token);
            storeAppSession(token, decoded, AUTH_MODE.SSO);
            const tenantType = decoded.tenantType;

            if (tenantType === "SCHOOL") {
                const url = env.baseURL + "/api/schoolYears?sort=enable,desc,name,desc";
                const config = {
                    headers: {
                        "content-type": "application/json",
                        Authorization: token,
                    },
                };
                axios
                    .get(url, config)
                    .then((rs) => {
                        if (rs.data) {
                            localStorage.setItem("schoolYears", JSON.stringify(rs.data.content));
                            localStorage.setItem("schoolYear", rs.data.content[0]);
                            window.history.replaceState({}, document.title, window.location.pathname);
                            window.location.replace("/#/");
                        }
                    })
                    .catch(() => {
                        // lỗi thì về lại trang login
                        window.location.replace("/#/login");
                    });
            } else {
                window.history.replaceState({}, document.title, window.location.pathname);
                window.location.replace("/#/");
            }
        } else {
            window.location.replace("/#/login");
        }
    }, []);

    return React.createElement(
        "div",
        {style: {padding: 24}},
        "Đang đăng nhập…"
    );
}
